import { BaseItem } from './common';

export const PRACTICE_GROUP_IDS_WITH_STATUS_MAP_EXCEPTIONS = [
  '068babf4-d36e-4cfa-bda1-607bbc89ab46',
];

export enum Status {
  TakingAsPrescribed = 'TAKING_AS_PRESCRIBED',
  TakingHeldDueToSurgery = 'TAKING_HELD_DUE_TO_SURGERY',
  TakingNotAsPrescribed = 'TAKING_NOT_AS_PRESCRIBED',
  TakingRefillsNeeded = 'TAKING_REFILLS_NEEDED',
  NotTaking = 'NOT_TAKING',
}

export const statusMap: Record<Status, string> = {
  [Status.TakingAsPrescribed]: 'Taking as prescribed',
  [Status.TakingHeldDueToSurgery]: 'Still taking, held due to surgery',
  [Status.TakingNotAsPrescribed]: 'Taking but not as prescribed',
  [Status.TakingRefillsNeeded]: 'Still taking, refills needed',
  [Status.NotTaking]: 'Not taking',
};

export enum Frequency {
  Daily = 'DAILY',
  TwiceADay = 'TWICE_A_DAY',
  ThreeTimesADay = '3_TIMES_A_DAY',
  FourTimesADay = '4_TIMES_A_DAY',
  FiveTimesADay = '5_TIMES_A_DAY',
  SixTimesADay = '6_TIMES_A_DAY',
  EveryOtherDay = 'EVERY_OTHER_DAY',
  EveryHour = 'EVERY_HOUR',
  EveryTwoHours = 'EVERY_2_HOURS',
  EveryThreeHours = 'EVERY_3_HOURS',
  EveryThreeToFourHours = 'EVERY_3-4_HOURS',
  EveryFourHours = 'EVERY_4_HOURS',
  EveryFourToSixHours = 'EVERY_4-6_HOURS',
  EverySixHours = 'EVERY_6_HOURS',
  EverySixToEightHours = 'EVERY_6-8_HOURS',
  EveryEightHours = 'EVERY_8_HOURS',
  EveryTwelveHours = 'EVERY_12_HOURS',
  EveryTwentyFourHours = 'EVERY_24_HOURS',
  EverySeventyTwoHours = 'EVERY_72_HOURS',
  EveryWeek = 'EVERY_WEEK',
  TwiceAWeek = 'TWICE_A_WEEK',
  ThreeTimesAWeek = '3_TIMES_A_WEEK',
  EveryTwoWeeks = 'EVERY_2_WEEKS',
  EveryThreeWeeks = 'EVERY_3_WEEKS',
  EveryFourWeeks = 'EVERY_4_WEEKS',
  EveryMonth = 'EVERY_MONTH',
  EveryTwoMonths = 'EVERY_2_MONTHS',
  EveryThreeMonths = 'EVERY_3_MONTHS',
  AsNeeded = 'AS_NEEDED',
}

export enum Source {
  Ehr = 'EHR',
  Previsit = 'PREVISIT',
}

export interface CreateValues {
  name: string;
  detailsRaw?: string | null;
  dosage?: string | null;
  frequency?: Frequency | null;
  source: Source;
}

interface DeleteValues {
  isDeleted: boolean;
  deletedTimestamp: Date | null;
}

export type UpdateValues = Partial<CreateValues & DeleteValues>;

export interface Medication extends BaseItem, CreateValues, DeleteValues {}

export interface PrevisitMedication
  extends Pick<
    BaseItem & CreateValues & DeleteValues,
    'id' | 'name' | 'detailsRaw' | 'isDeleted'
  > {
  status?: Status;
}
